import { motion } from "framer-motion";
import { whyUs } from "../data";

export default function WhyUs() {
  return (
    <section className="py-5">
      <div className="container py-5">
        <h2 className="text-center display-5 fw-bold mb-5">Почему выбирают нас</h2>
        <div className="row g-4">
          {whyUs.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.1 }}
              viewport={{ once: true }}
              className="col-md-6 col-lg-4"
            >
              <div className="d-flex align-items-center gap-3 p-4 bg-light rounded-3 h-100">
                <span className="display-4 text-danger">✓</span>
                <p className="fs-5 m-0 blackT">{item}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}